import React from "react";
import PageAskTeacherMain from "./AskTeacherMain";
import { Switch, useRouteMatch } from "react-router-dom";
import AskTeacherDetail from "./AskTeacherDetail";
import { LayoutRoute } from "../../components/LayoutRoute";
import { TopLayout } from "../../components/Layouts/TopLayout";
import { SubLayout } from "../../components/Layouts/SubLayout";

export default function AskTeacher() {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <LayoutRoute
                path={path}
                exact
                component={PageAskTeacherMain}
                layout={TopLayout}
            />

            <LayoutRoute
                path={`${path}/:batchNo/:courseNo/:courseSeq/:uuid`}
                exact
                component={AskTeacherDetail}
                layout={SubLayout}
            />
        </Switch>
    );
}
